module.exports = __webpack_public_path__ + "images/nzi.c537b0690230e2018cabe79c6cf52f51.png";